// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    id: z.string().min(1).optional(),
    tenantId: z.string().max(21).optional(),
    userId: z.string().min(1).max(21),
    tokenHash: z.string().min(1).max(128),
    deviceName: z.string().max(256).nullable().optional(),
    userAgent: z.string().nullable().optional(),
    ipAddress: z.string().max(64).nullable().optional(),
    lastUsedIp: z.string().max(64).nullable().optional(),
    createdAt: z.number().optional(),
    lastUsedAt: z.number().nullable().optional(),
    expiresAt: z.number(),
    revokedAt: z.number().nullable().optional(),
});
const guard = z.object({
    id: z.string(),
    tenantId: z.string().max(21),
    userId: z.string().min(1).max(21),
    tokenHash: z.string().min(1).max(128),
    deviceName: z.string().max(256).nullable(),
    userAgent: z.string().nullable(),
    ipAddress: z.string().max(64).nullable(),
    lastUsedIp: z.string().max(64).nullable(),
    createdAt: z.number(),
    lastUsedAt: z.number().nullable(),
    expiresAt: z.number(),
    revokedAt: z.number().nullable(),
});
export const TrustedDevices = Object.freeze({
    table: 'trusted_devices',
    tableSingular: 'trusted_device',
    fields: {
        id: 'id',
        tenantId: 'tenant_id',
        userId: 'user_id',
        tokenHash: 'token_hash',
        deviceName: 'device_name',
        userAgent: 'user_agent',
        ipAddress: 'ip_address',
        lastUsedIp: 'last_used_ip',
        createdAt: 'created_at',
        lastUsedAt: 'last_used_at',
        expiresAt: 'expires_at',
        revokedAt: 'revoked_at',
    },
    fieldKeys: [
        'id',
        'tenantId',
        'userId',
        'tokenHash',
        'deviceName',
        'userAgent',
        'ipAddress',
        'lastUsedIp',
        'createdAt',
        'lastUsedAt',
        'expiresAt',
        'revokedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
